<template>
  <img
    src="../assets/img/yescapa.svg"
    alt="Yescapa"
    width="148"
    height="32"
  >
</template>
